import type { App } from 'vue'
import axios from 'axios'

export const HTTP_PLUGIN_KEY = Symbol('http')

export const HttpPlugin = {
  install(app: App) {

    const http = axios.create({
      baseURL: import.meta.env.VITE_API_BASE_URL
    })

    app.provide(HTTP_PLUGIN_KEY, http)
  }
}